import {
  Box,
  Card,
  Typography,
  Button,
  Stack,
  Chip,
  Divider,
} from "@mui/material";
import Novm from '../../assets/novm.png'
import troubleshoot from '../../assets/troubleshooting.png'
import checkIcon from '../../assets/checkicone.png'

export default function NoActiveMachine({uuid,gotohome}) {
  console.log("uuid",uuid)
  return (
    <Box
      minHeight="100vh"
     /*  display="flex"
      alignItems="center"
      justifyContent="center" */
      //bgcolor="#f7f7f7"
      px={2}
      mt={10}
    >
      <Box width="100%" maxWidth={380} textAlign="center">
        {/* MAIN ICON */}
        <Box
          mx="auto"
          mb={2}
          width={110}
          height={110}
          borderRadius="50%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          
        >
          <img
            src={Novm}
            alt="No Active Machine"
            style={{ width: 96, height: 96 }}
          />
        </Box>

        {/* TITLE */}
        <Typography fontWeight={700} fontSize={20} mb={1}>
          No Active Machine Found
        </Typography>

        {/* UID */}
        <Chip
          label={`Unknown UID: ${uuid}`}
          sx={{
            bgcolor: "#fbe4e4",
            fontWeight: 600,
            mb: 2,
          }}
        />

        {/* SUBTEXT */}
        <Typography variant="body2" color="text.secondary" mb={3}>
          We couldn’t find an active vending machine linked to this UID
        </Typography>

        {/* TROUBLESHOOTING CARD */}
        <Card
          elevation={0}
          sx={{
            textAlign: "left",
            borderRadius: 3,
            p: 2,
            mb: 4,
            border: "1px solid #eee",
          }}
        >
          {/* Header */}
          <Stack direction="row" spacing={1.5} alignItems="center" mb={2}>
            <img
              src={troubleshoot}
              alt="Troubleshooting"
              style={{ width: 32, height: 32 }}
            />
            <Typography fontWeight={600}>
              Troubleshooting
            </Typography>
          </Stack>
          <div style={{padding:"10px",marginLeft: "-25px",marginRight:"-25px"}}>

          
          <Divider/>

          </div>

          <Stack spacing={2}>
            {/* Item 1 */}
            <Stack direction="row" spacing={1.5} alignItems="flex-start">
                  <img
            src={checkIcon}
            alt="No Active Machine"
            style={{ width: 20, height: 20 }}
          />
              <Box>
                <Typography fontWeight={600} variant="body2">
                  Check QR Code Clarity
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Make sure the QR sticker is clean, visible, and not damaged.
                </Typography>
              </Box>
            </Stack>

            {/* Item 2 */}
            <Stack direction="row" spacing={1.5} alignItems="flex-start">
                    <img
            src={checkIcon}
            alt="No Active Machine"
            style={{ width: 20, height: 20 }}
          />
              <Box>
                <Typography fontWeight={600} variant="body2">
                  Ensure Machine Is Active
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  The Kiosk Screen Should be ON and Responsive.
                </Typography>
              </Box>
            </Stack>
          </Stack>
        </Card>

        {/* BUTTON */}
        <Button
          fullWidth
              
          
          variant="contained"
          sx={{
            bgcolor: "#0aa36c",
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
            py: 1.2,
                width: "50%",
            "&:hover": { bgcolor: "#08915f" },
          }}
          onClick={(e)=>{gotohome()}}
        >

          Go To Home
        </Button>
      </Box>
    </Box>
  );
}
